import { render, staticRenderFns } from "./ChartDoughnut.vue?vue&type=template&id=2eca08d8&"
import script from "./ChartDoughnut.vue?vue&type=script&lang=ts&"
export * from "./ChartDoughnut.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports